import { lazy } from "react";
import Loadable from "components/Loadable";
import { routeConstants } from "services/keyConstants";
// Define lazy-loaded components
const View = Loadable(lazy(() => import("../View")));

// Define routes using lazy-loaded components
const ArchiveRoute = [
  {
    path: routeConstants.ARCHIVE,
    children: [
      { path: "view/*", element: <View /> }, // Wildcard (*) allows infinite nesting
    ],
  },
];
export default ArchiveRoute;
